import { Box } from '@alifd/next';
import React from "react";
import Skeleton from "../index";
export function MockProductCell() {
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    spacing: 8
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 60,
    height: 60,
    style: {
      borderRadius: 8
    }
  }), /*#__PURE__*/React.createElement(Box, {
    spacing: 8
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 100,
    height: 20
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: 150,
    height: 20
  })));
}